<template>
  <div class="absolute h-full w-full bg-white inset-0 flex justify-center items-center z-10">
    <img
      class="animate-spin"
      alt="Loading icon"
      src="@/assets/icons/loading.svg"
      width="100"
      height="100"
    />
  </div>
</template>
